import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DocumentationView from '../DocumentationView';
import JsonView from '../JsonView';
import TabMenu from '../../../shared/molecules/TabMenu';

const ViewPicker = ({ schema, exampleSchema }) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  const tabItems = [
    {
      label: t(
        'components.schema_documentation_modal.view_picker.documentation',
      ),
    },
    {
      label: t('components.schema_documentation_modal.view_picker.example'),
    },
    {
      label: t('components.schema_documentation_modal.view_picker.schema'),
    },
  ];

  return (
    <Stack gap={2}>
      <TabMenu
        tabItems={tabItems}
        currentTab={tab}
        handleChange={e => setTab(e)}
        isTranslated
      />

      {tab === 0 && <DocumentationView schema={schema} />}
      {tab === 1 && <JsonView schema={exampleSchema} />}
      {tab === 2 && <JsonView schema={schema} />}
    </Stack>
  );
};

ViewPicker.propTypes = {
  schema: PropTypes.object,
  exampleSchema: PropTypes.object,
};

export default ViewPicker;
